const menu = {
  'menu.brexit-guide': 'Download your free Brexit Guide',
  'menu.teflCourses': 'TEFL Courses',
  'menu.trinityCerttesol': 'Trinity CertTESOL Course',
  'menu.onlineTrinity': 'Part-Time Online Trinity CertTESOL Course',
  'menu.developingTeacher': 'Developing Teacher Course',
  'menu.developingTeacher&Spanish': 'Developing Teacher & Spanish Course',
  'menu.teachingYoungLearners': 'Teaching Young Learners',
  'menu.classesDeIngles': 'Clases de Inglés',
  'menu.allCourses': 'All courses',

  'menu.locations': 'Locations',
  'menu.barcelona': 'Life in Barcelona',
  'menu.seville': 'Seville',

  'menu.dates&fees': 'Dates & Fees',
  'menu.dates': 'Course Dates & Prices',
  'menu.paymentPlan': 'Payment Plan',
  'menu.specialOffers': 'Special Offers',
  'menu.work&Visas': 'Work & Visas',
  'menu.carrerService': 'Career Service',
  'menu.studentsVisas': 'Student Visas',
  'menu.accommodation': 'Accommodation',
  'menu.resources': 'Resources',

  'menu.about': 'About',
  'menu.teflIberiaStory': 'The TEFL Iberia Story',
  'menu.whatIsTefl': 'What Is TEFL?',
  'menu.accreditations': 'Accreditations',
  'menu.meetTheTeam': 'Meet The Team',
  'menu.teflIberiaGraduates': 'TEFL Iberia Graduates',
  'menu.workWithUs': 'Work With Us',
  'menu.entryRequirements': 'Entry Requirements',
  'menu.faqs': 'FAQs',
  'menu.blog': 'Blog',
  'menu.contact': 'Contact',
  'menu.applyNow': 'Apply Now',
  'menu.signUpNow': 'Sign Up Now',
  'menu.seeMoreAccommodationFAQs': 'See More Accommodation FAQs',
};

export default menu;
